import { styled } from '@material-ui/core/styles';

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  display: 'flex',
  height: '100%',
  overflow: 'hidden'
}));

export const ListContainer = styled('div')(({ theme }) => ({
  flexGrow: 1,
  height: '100%',
  overflowY: 'auto',
  paddingBottom: theme.spacing(3)
}));
export const EmptyListContainer = styled('div')({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
